import React from "react";
import { ThemeProvider } from "styled-components";

const Theme = {
  color: {
    BLACK_0: "#312E2B",
    BLACK_1: "#272522",
    BLACK_2: "#22201E",
    BLACK_3: "#1F1E1B",
    BLACK_4: "#0f0f0e",
    BLACK_5: "#000000",
    GRAY_0: "#c2c9cf",
    GRAY_1: "#7b8085",
    GRAY_2: "#53585C",
    GRAY_3: "#313538",
    WHITE_0: "#8f8f88",
    WHITE_1: "#B3B3B2",
    WHITE_2: "#FFF",
    BLUE_1: "#C8E5FC",
    BLUE_2: "#90CBF9",
    BLUE_3: "#59B0F6",
    BLUE_4: "#2196F3",
    BLUE_5: "#2181CD",
    BLUE_6: "#216BA6",
    BLUE_7: "#215680",
    RED_0: "#FF8C32",
    RED_1: "#FB772D",
    RED_2: "#F76129",
    RED_3: "#F34C24",
    RED_4: "#EE361F",
    RED_5: "#EA211B",
    RED_6: "#E60B16",
  },
  textColor: {
    light: "#d7e0da",
  },
  font: ["sans-serif", "Roboto"],
  fontSize: {
    small: "12px",
    medium: "14px",
    large: "16px",
  },
  fontFamily: {
    grenze: "Grenze Gotisch",
    vidaloka: "Vidaloka",
    recursive: "Recursive",
  },
  dimension: {
    navbar: {
      SIDE_WIDTH: "80px",
      FULL_WIDTH: "300px",
      SIDE_ICON_SIZE: "28",
    },
    electronHeader: {
      height: "40px",
    },
    playerSheet: {},
  },
  colorFilters: {
    // hex to filter : https://codepen.io/sosuke/pen/Pjoqqp
    //if svg is not black by default then prefix these : brightness(0) saturate(100%)
    blue: `invert(8%) sepia(94%) saturate(5215%) hue-rotate(243deg) brightness(124%) contrast(154%)`,
    yellowGreen: `invert(82%) sepia(5%) saturate(4478%) hue-rotate(40deg) brightness(79%) contrast(119%);`,
    white: `invert(84%) sepia(100%) saturate(0%) hue-rotate(99deg) brightness(104%) contrast(101%);`,
  },
  screenSize: {
    portrait: `(max-width:720px)`,
    miniWindow: `screen and (max-width:360px), screen and (max-height:400px)`,
  },
};

const MyThemeProvider = ({ children }) => (
  <ThemeProvider theme={Theme}>{children}</ThemeProvider>
);

export { MyThemeProvider as ThemeProvider, Theme };
